import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import { useAuth } from '../../authContext'
import NoAccessPage from '../layout/NoAccessPage'

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const { loading, isAuthenticated, hasAccess } = useAuth()

  useEffect(() => {
    if (loading || isAuthenticated) return
    window.location.href = '/auth/login'
  }, [loading, isAuthenticated])

  const render = props => {
    if (!isAuthenticated) return null
    return hasAccess ? <Component {...props} /> : <NoAccessPage />
  }

  return <Route path={path} render={render} {...rest} />
}

export default PrivateRoute
